module.exports = __webpack_public_path__ + "static/img/6.8488b50.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/9/1/1/zh/6.png
// module id = SrVk
// module chunks = 0